import { Component, input } from '@angular/core';
import { Router } from '@angular/router';
import { CoreService } from 'src/app/services/core/core.service';
import { VehicleProvider } from 'src/app/services/providers/vehicle-provider/vehicle-provider';

@Component({
  selector: 'app-safety-defects-warning',
  templateUrl: './safety-defects-warning.component.html',
  styleUrls: ['./safety-defects-warning.component.scss'],
  standalone: false,
})
export class SafetyDefectsWarningComponent {
  /* Inspection control number used for navigation */
  icnNo = input.required<string>();

  constructor(
    private readonly router: Router,
    private readonly coreService: CoreService,
    private readonly vehicleProvider: VehicleProvider
  ) { }

  /* Determines whether booking-related actions are permitted */
  checkBookingPermission(): boolean {
    return (
      this.coreService.isMenuExists('VendorLocator') ||
      this.coreService.isMenuExists('Request Service')
    );
  }

  /* Navigates to the unroadworthy defects details screen */
  async navigateUnroadworthyDefects(): Promise<void> {
    const vehicleData = await this.vehicleProvider.getVehicleByIcnNo(this.icnNo());
    const idx = await this.vehicleProvider.getVehicleIdx(this.icnNo());
    if (!vehicleData || idx == undefined) {
      return;
    }
    this.vehicleProvider.setSelectedVehicle(vehicleData, idx);

    this.router.navigateByUrl(`/unroadworthy-defects/${this.icnNo()}`);
  }

  get isMobileApp() {
    return this.coreService.isMobileApp;
  }

}
